
<template>
  <div class="complete_content">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="pageList"
    />
    <div class="container">
      <section>
        <div class="title">
          <h2>事前現場調査依頼完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>事前現場調査依頼を受け付けました。</li>
            <li>調査依頼メールを自動送信しました。</li>
            <li>
              <router-link to="/top">TOPへ戻る</router-link>
            </li>
          </ul>
        </div>
        <!-- <div class="logo">
          <h2><img :src="getImage('common/logo.png')" alt="ミリスタイル"></h2>
          <div>My size, My lifestyle.</div>
        </div> -->
      </section>
    </div>
    <dd-footer />
  </div>
</template>
<script>

import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'
import LoginForm from '../components/login/DcLoginForm'

export default {
  name: 'orderComplete',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-sitemap': SiteMap,
    'dd-login': LoginForm
  },
  data () {
    return {
      pageKey: 'orderComp',
      pageList: []
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    let topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    if (!topForm || Object.keys(topForm) <= 0) {
      this.pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    } else {
      this.pageList = topForm.pageList
      App.setLocalStorage(DC_STORAGE_KEY.PAGE_LIST, this.pageList)
    }
    App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)

    App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcBuildingResearchComplete.vue